import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import SvgIcon from '../SvgIcon/Base';
import { removeLocalStorage } from 'globalservices/storage';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import ParentStyled from './style';

export const loadComponetStyle = (ParentStyled, url) => {
  try {
    const style = require(`./${window?.$environment?.CURRENT_LAYOUT}`)?.default;
    return { ...ParentStyled, ...style };
  } catch (error) {
    return ParentStyled;
  }
};

const Styled = loadComponetStyle(ParentStyled, 'CautionIcon');
const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`../UI/Button/${layout}`));

const CautionIcon = ({ noButton, message }) => {
  const i18n = useTranslation();

  return (
    <Styled.Container>
      <SvgIcon value={mediaUrls.confirmIcon} />
      <h2 className="resetHeading">
        {message ||
          `Please logout any active sessions in the current browser and click the
        button below to continue.`}
      </h2>
      {!noButton && (
        <div className="cancelBtn">
          <Button
            label={i18n.t('common.ok')}
            type={'submit'}
            onClick={() => {
              removeLocalStorage('currentLayout');
              window.location.reload();
            }}
          />
        </div>
      )}
    </Styled.Container>
  );
};

export default CautionIcon;
